<template>
  <div class="engineering-report">
    <h2>
      <router-link
        :to="{
          name: 'Engineering Reports',
          params: {
            quoteNumber
          }
        }"
      >{{ quoteNumber }}</router-link>
    </h2>
    <h3 v-if="reportTitle">{{ reportTitle }}</h3>
    <template v-if="loading">
      <p class="loading-message message">Loading...</p>
    </template>
    <template v-else-if="rows && rows.length">
      <file-download-link :src="spreadsheetDownloadURL"/>
      <div class="engineering-report-table-wrapper">
        <table>
          <thead>
            <th v-for="columnHeader in columnHeaders" :key="columnHeader">
              <span>{{ columnHeader }}</span>
            </th>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.id">
              <td v-for="column in row" :key="column">
                <span>{{ column }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-else>
      <p class="no-data-message message">No data available.</p>
    </template>
  </div>
</template>
<script>

import FileDownloadLink from '../../components/FileDownloadLink.vue';

export default {
  props: {
    quoteNumber: String,
    slug: String
  },
  components: {
    FileDownloadLink
  },
  data() {
    return {
      apiURL: '/api/engineering-reports/',
      loading: false,
      reportTitle: '',
      rows: []
    }
  },
  computed: {
    columnHeaders() {
      return this.rows && this.rows.length && Object.keys(this.rows[0]);
    },
    spreadsheetDownloadURL() {
      return this.apiURL + this.quoteNumber + '/' + this.slug + '/excel';
    }
  },
  methods: {
    getData() {
      const url = this.apiURL + this.quoteNumber + '/' + this.slug;

      this.loading = true;

      this.$http
        .get(url)
        .then(response => {
          this.reportTitle = response.data.title;
          this.rows = response.data.rows;
        })
        .catch(error => {
          console.error(error);
          alert("There was a problem loading report data. Please refresh the page and try again.");
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },
  mounted() {
    this.getData();
  }
}
</script>
<style lang="scss">
  .engineering-report {
    .engineering-report-table-wrapper {
      overflow: auto;

      th {
        padding: 12px;
        background: linear-gradient(0deg,#092a60,#076bb8);
        color: #fff;
      }

      td {
        padding: 8px;
      }

      tr {
        &:nth-child(even) {
          td {
            background-color: #eee;
          }
        }
      }
    }
  }
</style>